package com.fireavert.properties.comm_v2_conversion_dialog

import com.fireavert.properties.logic.comm_v3_conversion_dialog.CommV2Conversion

class CommV2ConversionDialogController(private val useCase: CommV2Conversion) {
    fun close(propertyId: Int) = useCase.close(propertyId)
    suspend fun convertPropertyToCommV2(propertyId: Int) = useCase.convertPropertyToCommV2(propertyId)

}